"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EphemeralAlert = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var currency_1 = require("@nerdwallet/currency");
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var ephemeral_alert_module_css_1 = __importDefault(require("./ephemeral-alert.module.css"));
var numberFormatter = Intl.NumberFormat("en-US");
var DEFAULT_ALERT_WIDTH = "267px";
var PointsText = function (_a) {
    var points = _a.points;
    return (react_1.default.createElement("div", { className: ephemeral_alert_module_css_1.default.pointsContainer },
        react_1.default.createElement(currency_1.Text, { component: "span", tone: "positive", bold: true }, "+".concat(numberFormatter.format(points))),
        react_1.default.createElement(currency_1.Text, { component: "span", tone: "positive", size: "x-small", bold: true },
            "\u00A0",
            "PTS")));
};
var EphemeralAlert = function (_a) {
    var _b, _c;
    var onClick = _a.onClick, _d = _a.isLarge, isLarge = _d === void 0 ? false : _d, points = _a.points, text = _a.text, _e = _a.width, width = _e === void 0 ? DEFAULT_ALERT_WIDTH : _e;
    var Component = onClick ? "button" : "div";
    var size = isLarge ? 36 : 20;
    if (isLarge) {
        return (react_1.default.createElement(Component, { onClick: onClick, className: (0, classnames_1.default)(ephemeral_alert_module_css_1.default.container, ephemeral_alert_module_css_1.default.containerLarge, (_b = {},
                _b[ephemeral_alert_module_css_1.default.containerTouchable] = !!onClick,
                _b)), style: {
                width: width,
            } },
            react_1.default.createElement("div", { className: ephemeral_alert_module_css_1.default.starContainer },
                react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { width: size, height: size, logoColor: "green-darkest", small: true })),
            react_1.default.createElement("div", { className: ephemeral_alert_module_css_1.default.textContainerLarge },
                react_1.default.createElement("span", { className: (0, classnames_1.default)(ephemeral_alert_module_css_1.default.descriptionText, ephemeral_alert_module_css_1.default.descriptionTextLarge) }, text),
                react_1.default.createElement(PointsText, { points: points }))));
    }
    return (react_1.default.createElement(Component, { onClick: onClick, className: (0, classnames_1.default)(ephemeral_alert_module_css_1.default.container, (_c = {},
            _c[ephemeral_alert_module_css_1.default.containerTouchable] = !!onClick,
            _c)), style: {
            width: width,
        } },
        react_1.default.createElement("div", { className: ephemeral_alert_module_css_1.default.starContainer },
            react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { width: size, height: size, logoColor: "green-darkest", small: true })),
        react_1.default.createElement("div", { className: ephemeral_alert_module_css_1.default.textContainerSmall },
            react_1.default.createElement("span", { className: ephemeral_alert_module_css_1.default.descriptionText }, text),
            react_1.default.createElement(PointsText, { points: points }))));
};
exports.EphemeralAlert = EphemeralAlert;
